import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import Compressor from 'compressorjs';

import { Button, DatePicker, Form, Grid, Input, Modal, NavBar, Picker, Result, SafeArea, Selector, Space, Steps, Toast } from "antd-mobile";
import { AddCircleOutline } from 'antd-mobile-icons'

import { getBankCardOcrData, getDictList, getIdcardOcrData, IDictData, uploadFile } from "../apis/common";
import { codeType, getCompanyIdByCode, getUserInitData, login, loginType, register, sendVCode } from "../apis/user";
import { useGlobalCountDownSec } from "../utils/countdown";

import idcardBackImg from '@assets/images/register/idcard_back.png';
import idcardFrontImg from '@assets/images/register/idcard_front.png';
import bankCardImg from '@assets/images/register/bank_card.png';
import stockPhotosImg from '@assets/images/register/stock_photos.png';
import academicCredentialsImg from '@assets/images/register/academic_credentials.png';
import socialCardImg from '@assets/images/register/social_card.png';
import fundCardImg from '@assets/images/register/fund_card.png';
import leavingCertificateImg from '@assets/images/register/leaving_certificate.png';

import './register.scss';
import { ToastHandler } from "antd-mobile/es/components/toast";
import dayjs from "dayjs";
import { LocationCascader } from "../components/locationCascader";

const now = new Date();
const minDate = dayjs().subtract(100, 'years').toDate();
const maxDate = dayjs().add(100, 'years').toDate();

const { Step } = Steps;
// 验证手机号正则
const pattern = /^1[23456789]\d{9}$/;

function isIOS() { // ios终端
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}
function isAndroid() { // android终端
    return navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
}
function isWeixin() { // 微信浏览器
    return /MicroMessenger|WeXin|WeChat/g.test(navigator.userAgent)
}


function RegisterPage() {
    // 滚动
    const idcard_image = useRef<HTMLDivElement>(null);
    const name = useRef<HTMLDivElement>(null);
    const nation_id_arr = useRef<HTMLDivElement>(null);
    const idcard = useRef<HTMLDivElement>(null);
    const idcard_begin_date_obj = useRef<HTMLDivElement>(null);
    const idcard_expire_date_obj = useRef<HTMLDivElement>(null);
    const sex_arr = useRef<HTMLDivElement>(null);
    const birthday_obj = useRef<HTMLDivElement>(null);
    const native_address = useRef<HTMLDivElement>(null);
    const mobile = useRef<HTMLDivElement>(null);
    const cur_id = useRef<HTMLDivElement>(null);
    const cur_address = useRef<HTMLDivElement>(null);
    const marry_status_arr = useRef<HTMLDivElement>(null);
    const is_birth_arr = useRef<HTMLDivElement>(null);
    const polity_face_arr = useRef<HTMLDivElement>(null);
    const household_type_arr = useRef<HTMLDivElement>(null);
    const email = useRef<HTMLDivElement>(null);
    const is_disease_arr = useRef<HTMLDivElement>(null);
    const disease_desc = useRef<HTMLDivElement>(null);
    const is_disability_arr = useRef<HTMLDivElement>(null);
    const disability_desc = useRef<HTMLDivElement>(null);
    const is_done_harmful_job_arr = useRef<HTMLDivElement>(null);
    const harmful_job_desc = useRef<HTMLDivElement>(null);
    const is_occupational_disease_arr = useRef<HTMLDivElement>(null);
    const occupational_disease_desc = useRef<HTMLDivElement>(null);
    const ec_name = useRef<HTMLDivElement>(null);
    const ec_relation_arr = useRef<HTMLDivElement>(null);
    const ec_mobile = useRef<HTMLDivElement>(null);
    const ec_address = useRef<HTMLDivElement>(null);

    // 步骤
    const [step, setStep] = useState(0);
    const stepButtonText = ['下一步', '提交信息', '下载思博达app'];

    // 表单
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const handler = useRef<ToastHandler>();

    // 组件弹出框
    const [birthdayPickerVisible, setBirthdayPickerVisible] = useState(false);
    const [curLocationPickerVisible, setCurLocationPickerVisible] = useState(false);
    const [idCardBeginDatePickerVisible, setIdCardBeginDatePickerVisible] = useState(false);
    const [idCardEndDatePickerVisible, setIdCardEndDatePickerVisible] = useState(false);
    const [eduBeginDatePickerVisible, setEduBeginDatePickerVisible] = useState(false);
    const [eduEndDatePickerVisible, setEduEndDatePickerVisible] = useState(false);
    const [jobBeginDatePickerVisible, setJobBeginDatePickerVisible] = useState(false);
    const [jobEndDatePickerVisible, setJobEndDatePickerVisible] = useState(false);

    // 验证码冷却
    const [countdown, startCountdown] = useGlobalCountDownSec(60, 'getLoginCode');

    // 企业名称
    const [companyName, setCompanyName] = useState<string>();

    // 初始化
    useEffect(() => {
        handler.current = Toast.show({
            content: '正在初始化，请稍等',
            duration: 0,
            icon: 'loading',
            maskClickable: false,
        });

        // 加载invitation_code
        function getQueryString(name: string) {
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            let r = window.location.search.substring(1).match(reg); //获取url中"?"符后的字符串并正则匹配
            let context = "";
            if (r != null)
                context = decodeURIComponent(r[2]);
            return context == null || context == "" || context == "undefined" ? "" : context;
        }
        let code = getQueryString('code');
        form.setFieldValue('invitation_code', code);
        getCompanyIdByCode({ invition_code: code }).then(res => {
            form.setFieldValue('company_id', res.data.id);
            setCompanyName(res.data.name);

            handler.current?.close();
        }).catch(e => {
            console.error(e);
            handler.current?.close();
            Toast.show({
                icon: 'fail',
                content: '链接信息出现错误',
            });
            setStep(3);
        });
    }, []);

    const checkMobile = (_: any, value: string) => {
        console.log(_, value);
        if (!value) {
            return Promise.reject(new Error('请输入手机号'));
        }
        if (!pattern.test(value)) {
            return Promise.reject(new Error('手机号不正确'));
        }
        return Promise.resolve();
    }

    const getVCode = async () => {
        try {
            await form.validateFields(['mobile']);
            let mobile = form.getFieldValue('mobile');
            // 开始倒计时
            startCountdown();
            try {
                await sendVCode({
                    mobile: mobile,
                    type: codeType.login,
                });
                Toast.show({
                    icon: 'success',
                    content: '验证码短信已下发',
                });

            } catch (e) {
                console.error(e);
            }
        } catch (e) {
            console.error(e);
        }
    }

    const onFinish = async () => {
        try {
            let res = await form.validateFields();
            console.log(res);
        } catch (e: any) {
            console.error(e);
            switch (e.errorFields[0].name[0]) {
                case 'idcard_image':
                    {
                        const top = idcard_image.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'name':
                    {
                        const top = name.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'nation_id_arr':
                    {
                        const top = nation_id_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'idcard':
                    {
                        const top = idcard.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'idcard_begin_date_obj':
                    {
                        const top = idcard_begin_date_obj.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'idcard_expire_date_obj':
                    {
                        const top = idcard_expire_date_obj.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'sex_arr':
                    {
                        const top = sex_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'birthday_obj':
                    {
                        const top = birthday_obj.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'native_address':
                    {
                        const top = native_address.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'mobile':
                    {
                        const top = mobile.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'cur_id':
                    {
                        const top = cur_id.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'cur_address':
                    {
                        const top = cur_address.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'marry_status_arr':
                    {
                        const top = marry_status_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'is_birth_arr':
                    {
                        const top = is_birth_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'polity_face_arr':
                    {
                        const top = polity_face_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'household_type_arr':
                    {
                        const top = household_type_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'email':
                    {
                        const top = email.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'is_disease_arr':
                    {
                        const top = is_disease_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'disease_desc':
                    {
                        const top = disease_desc.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'is_disability_arr':
                    {
                        const top = is_disability_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'disability_desc':
                    {
                        const top = disability_desc.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'is_done_harmful_job_arr':
                    {
                        const top = is_done_harmful_job_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'harmful_job_desc':
                    {
                        const top = harmful_job_desc.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'is_occupational_disease_arr':
                    {
                        const top = is_occupational_disease_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'occupational_disease_desc':
                    {
                        const top = occupational_disease_desc.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'ec_name':
                    {
                        const top = ec_name.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'ec_relation_arr':
                    {
                        const top = ec_relation_arr.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'ec_mobile':
                    {
                        const top = ec_mobile.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                case 'ec_address':
                    {
                        const top = ec_address.current?.getBoundingClientRect().top!;
                        window.scrollTo({
                            top: top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    break;
                default:
                    break;
            }
            return;
        }

        switch (step) {
            case 0:
                try {
                    setLoading(true);
                    let _form = form.getFieldsValue(true);
                    // 登录
                    let res = await login({
                        login_type: loginType.code,
                        mobile: _form.mobile,
                        code: _form.code
                    });
                    localStorage.setItem('token', res.data.token);

                    // 获取用户初始化信息
                    let initRes = await getUserInitData();
                    if (initRes.data.staff) {
                        // 已注册
                        Modal.alert({
                            content: '该手机号已经入职，无法重复注册！',
                        });
                    } else if (initRes.data.entry_apply) {
                        // 已注册
                        Modal.alert({
                            content: '该手机号已经提交入职申请，请等待企业审核！',
                        });
                    } else if (initRes.data.company_apply) {
                        Modal.alert({
                            content: '该手机号正在申请成为企业，无法重复注册！',
                        });
                    } else {
                        setStep(1);
                    }
                } catch (e) {
                    console.error(e);
                } finally {
                    setLoading(false);
                }
                break;

            case 1:
                let _form = form.getFieldsValue(true);
                // 提交
                handler.current = Toast.show({
                    content: '正在提交表单，请稍等',
                    icon: 'loading',
                    duration: 0,
                    maskClickable: false,
                });

                try {
                    let res = await register({
                        ..._form,
                        edu_exp: _form.edu_exp ?? [],
                        job_exp: _form.job_exp ?? []
                    });
                    Toast.show({
                        icon: 'success',
                        content: res.msg,
                    });
                    setStep(2);
                } catch (e) {
                    handler.current?.close();
                    console.error(e);
                }
                break;
            case 2:
                if (isWeixin()) {
                    Modal.alert({
                        content: '微信内置浏览器，不能直接跳转应用商城，请到应用商城搜索“和谐劳务”进行下载！谢谢！',
                    });
                } else if (isIOS()) { // android
                    window.open(`https://apps.apple.com/app/%E5%92%8C%E8%B0%90%E5%8A%B3%E5%8A%A1/id1618889087`, '_blank');
                } else if (isAndroid()) { // ios
                    window.open(`market://details?id=com.siboda.hr_flutter`, '_blank');
                } else {
                    Modal.alert({
                        content: '无法识别当前设备，不能直接跳转应用商城，请到应用商城搜索“和谐劳务”进行下载！谢谢！',
                    });
                }
                break;

            default:
                break;
        }
    }

    // 选项列表
    const [nation, setNation] = useState<IDictData>();
    const [sex, setSex] = useState<IDictData>();
    const [marryType, setMarryType] = useState<IDictData>();
    const [face, setFace] = useState<IDictData>();
    const [residenceType, setResidenceType] = useState<IDictData>();
    const [relationship, setRelationship] = useState<IDictData>();
    useEffect(() => {
        getDictList(['sys_nation', 'global_sex', 'sys_marry_type', 'sys_face', 'sys_residence_type', 'sys_relationship']).then(res => {
            setNation(res.data.sys_nation);
            setSex(res.data.global_sex);
            setMarryType(res.data.sys_marry_type);
            setFace(res.data.sys_face);
            setResidenceType(res.data.sys_residence_type);
            setRelationship(res.data.sys_relationship);
        });
    }, []);

    // 上传身份证国徽面
    const inputIdcardFrontRef = React.createRef<HTMLInputElement>();
    const [inputIdcardFrontImg, setInputIdcardFrontImg] = useState<string>();
    const uploadIdcardFront = async (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return;
        let files = event.target.files;
        handler.current = Toast.show({
            content: '正在上传文件，请稍等',
            icon: 'loading',
            duration: 0,
            maskClickable: false,
        })

        // 压缩
        new Compressor(files[0], {
            quality: 0.6,
            success(result) {
                let file = new File([result], files[0].name);
                uploadFile({ file: file, type: 'idcard' }).then(res => {
                    setInputIdcardFrontImg(res.data.full_link);
                    form.setFieldValue('idcard_front_img', res.data.file_id);
                    getIdcardOcrData({ fid: res.data.file_id }).then(res => {
                        let data = res.data;
                        if (data.valid_date_start) {
                            form.setFieldValue('idcard_begin_date_obj', dayjs(data.valid_date_start).toDate());
                            form.setFieldValue('idcard_begin_date', data.valid_date_start);
                        }
                        if (data.valid_date_end) {
                            form.setFieldValue('idcard_expire_date_obj', dayjs(data.valid_date_end).toDate());
                            form.setFieldValue('idcard_expire_date', data.valid_date_end);
                        }
                    });
                    handler.current?.close();
                });
            },
            error(err) {
                console.log(err.message);
                handler.current?.close();
                Toast.show({
                    icon: 'fail',
                    content: '压缩过程出现错误',
                })
            },
        });
    };
    // 上传身份证人像面
    const inputIdcardBackRef = React.createRef<HTMLInputElement>();
    const [inputIdcardBackImg, setInputIdcardBackImg] = useState<string>();
    const uploadIdcardBack = async (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return;
        let files = event.target.files;
        handler.current = Toast.show({
            content: '正在上传文件，请稍等',
            icon: 'loading',
            duration: 0,
            maskClickable: false,
        });

        // 压缩
        new Compressor(files[0], {
            quality: 0.6,
            success(result) {
                let file = new File([result], files[0].name);
                uploadFile({ file: file, type: 'idcard' }).then(res => {
                    setInputIdcardBackImg(res.data.full_link);
                    form.setFieldValue('idcard_back_img', res.data.file_id);
                    getIdcardOcrData({ fid: res.data.file_id }).then(res => {
                        let data = res.data;
                        form.setFieldsValue({
                            name: data.name,
                            sex: data.sex_code,
                            sex_arr: [data.sex_code],
                            nation_id: data.nation_code,
                            nation_id_arr: [data.nation_code],
                            birthday: data.birth ? data.birth : undefined,
                            birthday_obj: data.birth ? dayjs(data.birth).toDate() : undefined,
                            native_address: data.address,
                            idcard: data.id_num,
                        });
                    });
                    handler.current?.close();
                });
            },
            error(err) {
                console.log(err.message);
                handler.current?.close();
                Toast.show({
                    icon: 'fail',
                    content: '压缩过程出现错误',
                });
            },
        });
    };

    // 上传银行卡
    const inputBankCardRef = React.createRef<HTMLInputElement>();
    const [inputBankCardImg, setInputBankCardImg] = useState<string>();
    const uploadBankCard = async (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return;
        let files = event.target.files;
        handler.current = Toast.show({
            content: '正在上传文件，请稍等',
            icon: 'loading',
            duration: 0,
            maskClickable: false,
        });

        // 压缩
        new Compressor(files[0], {
            quality: 0.6,
            success(result) {
                let file = new File([result], files[0].name);
                uploadFile({ file: file, type: 'bank_card' }).then(res => {
                    setInputBankCardImg(res.data.full_link);
                    form.setFieldValue('bank_card_img', res.data.file_id);

                    // ocr
                    getBankCardOcrData({ file_id: res.data.file_id }).then(bankCardOcrRes => {
                        let data = bankCardOcrRes.data;
                        form.setFieldsValue({
                            ...data
                        });
                    });

                    handler.current?.close();
                });
            },
            error(err) {
                console.log(err.message);
                handler.current?.close();
                Toast.show({
                    icon: 'fail',
                    content: '压缩过程出现错误',
                });
            },
        });
    };

    // 个人证件照
    const inputStockPhotoRef = React.createRef<HTMLInputElement>();
    const [inputStockPhotoImg, setInputStockPhotoImg] = useState<string>();
    const uploadStockPhoto = async (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return;
        let files = event.target.files;
        handler.current = Toast.show({
            content: '正在上传文件，请稍等',
            duration: 0,
            icon: 'loading',
            maskClickable: false,
        });

        // 压缩
        new Compressor(files[0], {
            quality: 0.6,
            success(result) {
                let file = new File([result], files[0].name);
                uploadFile({ file: file, type: 'default' }).then(res => {
                    setInputStockPhotoImg(res.data.full_link);
                    form.setFieldValue('staff_img', res.data.file_id);
                    handler.current?.close();
                });
            },
            error(err) {
                console.log(err.message);
                handler.current?.close();
                Toast.show({
                    icon: 'fail',
                    content: '压缩过程出现错误',
                });
            },
        });
    };

    // 社保卡
    const inputAcademicCredentialRef = React.createRef<HTMLInputElement>();
    const [inputAcademicCredentialImg, setInputAcademicCredentialImg] = useState<string>();
    const uploadAcademicCredential = async (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return;
        let files = event.target.files;
        handler.current = Toast.show({
            content: '正在上传文件，请稍等',
            duration: 0,
            icon: 'loading',
            maskClickable: false,
        });

        // 压缩
        new Compressor(files[0], {
            quality: 0.6,
            success(result) {
                let file = new File([result], files[0].name);
                uploadFile({ file: file, type: 'default' }).then(res => {
                    setInputAcademicCredentialImg(res.data.full_link);
                    form.setFieldValue('edu_prove_img', res.data.file_id);
                    handler.current?.close();
                });
            },
            error(err) {
                console.log(err.message);
                handler.current?.close();
                Toast.show({
                    icon: 'fail',
                    content: '压缩过程出现错误',
                });
            },
        });
    };

    // 社保卡
    const inputSocialCardRef = React.createRef<HTMLInputElement>();
    const [inputSocialCardImg, setInputSocialCardImg] = useState<string>();
    const uploadSocialCard = async (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return;
        let files = event.target.files;
        handler.current = Toast.show({
            content: '正在上传文件，请稍等',
            duration: 0,
            icon: 'loading',
            maskClickable: false,
        });

        // 压缩
        new Compressor(files[0], {
            quality: 0.6,
            success(result) {
                let file = new File([result], files[0].name);
                uploadFile({ file: file, type: 'default' }).then(res => {
                    if ('data' in res) {
                        setInputSocialCardImg(res.data.full_link);
                        form.setFieldValue('social_card_img', res.data.file_id);
                    }
                    handler.current?.close();
                });
            },
            error(err) {
                console.log(err.message);
                handler.current?.close();
                Toast.show({
                    icon: 'fail',
                    content: '压缩过程出现错误',
                });
            },
        });
    };

    // 公积金卡
    const inputFundCardRef = React.createRef<HTMLInputElement>();
    const [inputFundCardImg, setInputFundCardImg] = useState<string>();
    const uploadFundCard = async (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return;
        let files = event.target.files;
        handler.current = Toast.show({
            content: '正在上传文件，请稍等',
            duration: 0,
            icon: 'loading',
            maskClickable: false,
        });

        // 压缩
        new Compressor(files[0], {
            quality: 0.6,
            success(result) {
                let file = new File([result], files[0].name);
                uploadFile({ file: file, type: 'default' }).then(res => {
                    setInputFundCardImg(res.data.full_link);
                    form.setFieldValue('fund_card_img', res.data.file_id);
                    handler.current?.close();
                });
            },
            error(err) {
                console.log(err.message);
                handler.current?.close();
                Toast.show({
                    icon: 'fail',
                    content: '压缩过程出现错误',
                });
            },
        });
    };

    // 离职证明
    const inputLeavingCertificateRef = React.createRef<HTMLInputElement>();
    const [inputLeavingCertificateImg, setInputLeavingCertificateImg] = useState<string>();
    const uploadLeavingCertificate = async (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return;
        let files = event.target.files;
        handler.current = Toast.show({
            content: '正在上传文件，请稍等',
            duration: 0,
            icon: 'loading',
            maskClickable: false,
        });

        // 压缩
        new Compressor(files[0], {
            quality: 0.6,
            success(result) {
                let file = new File([result], files[0].name);
                uploadFile({ file: file, type: 'default' }).then(res => {
                    setInputLeavingCertificateImg(res.data.full_link);
                    form.setFieldValue('quit_img', res.data.file_id);
                    handler.current?.close();
                });
            },
            error(err) {
                console.log(err.message);
                handler.current?.close();
                Toast.show({
                    icon: 'fail',
                    content: '压缩过程出现错误',
                });
            },
        });
    };

    return (
        <>
            <NavBar backArrow={false} style={{ backgroundColor: "white" }}>员工入职 - {companyName ?? '初始化中'}</NavBar>
            <Steps current={step}>
                <Step title='第一步' description='手机号注册' />
                <Step title='第二步' description='输入信息' />
                <Step title='第三步' description='下载app' />
            </Steps>
            <Form
                form={form}
                name='form'
                layout='vertical'
                footer={
                    <>
                        {
                            step < 3 &&
                            <Button loading={loading} block color='primary' size='large' onClick={onFinish}>
                                {stepButtonText[step]}
                            </Button>
                        }
                        {/* <Button block color='primary' size='large' onClick={
                            () => {
                                console.log(form.getFieldsValue(true));
                            }
                        }>
                            test
                        </Button> */}
                    </>

                }
            >
                {
                    step === 0 &&
                    <>
                        <Form.Item
                            required
                            name='mobile'
                            label='手机号'
                            rules={[{ validator: checkMobile }]}
                            extra={
                                <div className="extra_part">
                                    <Button
                                        size="small"
                                        loading={countdown > 0}
                                        loadingText={`${countdown}s`}
                                        onClick={getVCode}
                                    >获取验证码</Button>
                                </div>
                            }
                        >
                            <Input placeholder='请输入手机号' />
                        </Form.Item>
                        <Form.Item name='code' label='验证码' rules={[{ required: true }]}>
                            <Input placeholder='请输入验证码' maxLength={10} />
                        </Form.Item>
                    </>
                }
                {
                    step === 1 &&
                    <>
                        {/* 公司邀请码 */}
                        <Form.Item
                            name="invitation_code"
                            label='公司邀请码'
                            rules={[
                                { required: true, message: '请输入公司邀请码' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (value?.length == 6 && getFieldValue('company_id')) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('请输入正确的公司邀请码'));
                                    },
                                }),
                            ]}
                        >
                            <Input
                                readOnly
                                maxLength={6}
                                placeholder="请输入公司邀请码"
                            />
                        </Form.Item>

                        {/* 身份证正反面 */}
                        <div ref={idcard_image}>
                            <Form.Item
                                name="idcard_image"
                                label="身份证"
                                required
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (getFieldValue('idcard_front_img') && getFieldValue('idcard_back_img')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('请上传身份证'));
                                        },
                                    }),
                                ]}
                            >
                                <Grid columns={2} gap={10}>
                                    <Grid.Item>
                                        <img
                                            src={inputIdcardBackImg ?? idcardBackImg}
                                            style={{ width: "80%", cursor: 'pointer', margin: '0 10%', objectFit: 'contain' }}
                                            alt="身份证人像面"
                                            onClick={() => inputIdcardBackRef.current?.click()}
                                        />
                                        <input
                                            ref={inputIdcardBackRef}
                                            style={{ display: 'none' }}
                                            type="file"
                                            accept='image/jpeg,image/jpg,image/png'
                                            onChange={uploadIdcardBack}
                                        />
                                    </Grid.Item>
                                    <Grid.Item>
                                        <img
                                            src={inputIdcardFrontImg ?? idcardFrontImg}
                                            style={{ width: "80%", cursor: 'pointer', margin: '0 10%', objectFit: 'contain' }}
                                            alt="身份证国徽面"
                                            onClick={() => inputIdcardFrontRef.current?.click()}
                                        />
                                        <input
                                            ref={inputIdcardFrontRef}
                                            style={{ display: 'none' }}
                                            type="file"
                                            accept='image/jpeg,image/jpg,image/png'
                                            onChange={uploadIdcardFront}
                                        />
                                    </Grid.Item>
                                </Grid>
                            </Form.Item>
                        </div>

                        {/* 姓名 */}
                        <div ref={name} >
                            <Form.Item
                                name="name"
                                label="姓名"
                                rules={[{ required: true, message: '请输入姓名' }]}
                            >
                                <Input placeholder="姓名" maxLength={10} />
                            </Form.Item>
                        </div>

                        {/* 民族 */}
                        <div ref={nation_id_arr}>
                            <Form.Item
                                name="nation_id_arr"
                                label="民族"
                                rules={[{ required: true, message: '请选择民族' }]}
                                trigger="onConfirm"
                            >
                                <Picker
                                    columns={[nation?.options.map(item => ({
                                        label: item.name,
                                        value: item.value,
                                    })) ?? []]}
                                    onConfirm={(value) => {
                                        form.setFieldValue('nation_id', value[0]);
                                    }}
                                >
                                    {(items, { open }) => {
                                        return (
                                            <Space align='center'>
                                                <Button onClick={open}>选择</Button>
                                                {items.every(item => item === null)
                                                    ? '未选择'
                                                    : items.map(item => item?.label ?? '未选择').join(' - ')}
                                            </Space>
                                        )
                                    }}
                                </Picker>
                            </Form.Item>
                        </div>

                        {/* 身份证号 */}
                        <div ref={idcard}>
                            <Form.Item
                                name="idcard"
                                label="身份证号"
                                rules={[{ required: true, message: '请输入身份证号' }]}
                            >
                                <Input placeholder="身份证号" maxLength={18} />
                            </Form.Item>
                        </div>

                        {/* 身份证有效期 */}
                        <div ref={idcard_begin_date_obj}>
                            <Form.Item
                                name='idcard_begin_date_obj'
                                label="身份证有效期-开始时间"
                                required
                            >
                                <Space align='center'>
                                    <Button

                                        onClick={() => {
                                            setIdCardBeginDatePickerVisible(true)
                                        }}
                                    >
                                        选择
                                    </Button>
                                    <Form.Item
                                        name='idcard_begin_date_obj'
                                        trigger="onConfirm"
                                        noStyle
                                        rules={[{ required: true, message: '请选择身份证有效期开始时间' }]}

                                    >
                                        <DatePicker
                                            visible={idCardBeginDatePickerVisible}
                                            onClose={() => {
                                                setIdCardBeginDatePickerVisible(false)
                                            }}
                                            max={now}
                                            min={minDate}
                                            onConfirm={(value) => {
                                                form.setFieldValue('idcard_begin_date', dayjs(value).format('YYYY-MM-DD'));
                                            }}
                                        >
                                            {value => value ? dayjs(value).format('YYYY-MM-DD') : '未选择'}
                                        </DatePicker>
                                    </Form.Item>
                                </Space>
                            </Form.Item>
                        </div>

                        <div ref={idcard_expire_date_obj}>
                            <Form.Item
                                name='idcard_expire_date_obj'
                                label="身份证有效期-过期时间"
                                required
                            >
                                <Space align='center'>
                                    <Button

                                        onClick={() => {
                                            setIdCardEndDatePickerVisible(true)
                                        }}
                                    >
                                        选择
                                    </Button>
                                    <Form.Item
                                        name='idcard_expire_date_obj'
                                        trigger="onConfirm"
                                        noStyle
                                        rules={[{ required: true, message: '请选择身份证有效期过期时间' }]}

                                    >
                                        <DatePicker
                                            visible={idCardEndDatePickerVisible}
                                            onClose={() => {
                                                setIdCardEndDatePickerVisible(false)
                                            }}
                                            max={maxDate}
                                            min={now}
                                            onConfirm={(value) => {
                                                form.setFieldValue('idcard_expire_date', dayjs(value).format('YYYY-MM-DD'));
                                            }}
                                        >
                                            {value => value ? dayjs(value).format('YYYY-MM-DD') : '未选择'}
                                        </DatePicker>
                                    </Form.Item>
                                </Space>
                            </Form.Item>
                        </div>

                        {/* 性别 */}
                        <div ref={sex_arr}>
                            <Form.Item
                                name="sex_arr"
                                label="性别"
                                rules={[{ required: true, message: '请选择性别' }]}
                            >
                                <Selector

                                    options={sex?.options.map(item => ({
                                        label: item.name,
                                        value: item.value,
                                    })) ?? []}
                                    onChange={(value) => {
                                        form.setFieldValue('sex', value[0]);
                                    }}
                                />
                            </Form.Item>
                        </div>

                        {/* 出生日期 */}
                        <div ref={birthday_obj}>
                            <Form.Item
                                name='birthday_obj'
                                label="出生日期"
                                required
                            >
                                <Space align='center'>
                                    <Button
                                        onClick={() => {
                                            setBirthdayPickerVisible(true)
                                        }}
                                    >
                                        选择
                                    </Button>
                                    <Form.Item
                                        name='birthday_obj'
                                        trigger="onConfirm"
                                        noStyle
                                        rules={[{ required: true, message: '请选择出生日期' }]}

                                    >
                                        <DatePicker
                                            visible={birthdayPickerVisible}
                                            onClose={() => {
                                                setBirthdayPickerVisible(false)
                                            }}
                                            max={now}
                                            min={minDate}
                                            onConfirm={(value) => {
                                                form.setFieldValue('birthday', dayjs(value).format('YYYY-MM-DD'));
                                            }}
                                        >
                                            {value => value ? dayjs(value).format('YYYY-MM-DD') : '未选择'}
                                        </DatePicker>
                                    </Form.Item>
                                </Space>
                            </Form.Item>
                        </div>

                        {/* 户籍地址 */}
                        <div ref={native_address}>
                            <Form.Item
                                name="native_address"
                                label="户籍地址"
                                rules={[{ required: true, message: '请输入户籍地址' }]}
                            >
                                <Input placeholder="户籍地址" maxLength={100} />
                            </Form.Item>
                        </div>


                        {/* 手机号 */}
                        <div ref={mobile}>
                            <Form.Item
                                name="mobile"
                                label="手机号"
                                rules={[{ required: true, message: '请输入手机号' }]}
                            >
                                <Input placeholder="手机号" maxLength={11} />
                            </Form.Item>
                        </div>

                        <div ref={cur_id}>
                            <Form.Item
                                label="现住地址"
                                name="cur_id"
                                required
                            >
                                <Space align='center'>
                                    <Button

                                        onClick={() => {
                                            setCurLocationPickerVisible(true)
                                        }}
                                    >
                                        选择
                                    </Button>
                                    <Form.Item
                                        name="cur_id"
                                        trigger="onConfirm"
                                        noStyle
                                        rules={[
                                            { required: true, message: '请选择现住地址' },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (value?.length == 4) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('请选择完整的地址'));
                                                },
                                            }),
                                        ]}
                                    >
                                        <LocationCascader
                                            visible={curLocationPickerVisible}
                                            onClose={
                                                () => setCurLocationPickerVisible(false)
                                            }
                                            onConfirm={(values) => {
                                                if (values.length === 4) {
                                                    form.setFieldsValue({
                                                        cur_province_id: Number(values[0]),
                                                        cur_city_id: Number(values[1]),
                                                        cur_area_id: Number(values[2]),
                                                        cur_street_id: Number(values[3]),
                                                    });
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                </Space>
                            </Form.Item>
                        </div>

                        {/* 详细地址 */}
                        <div ref={cur_address}>
                            <Form.Item
                                name="cur_address"
                                label="现住详细地址"
                                rules={[{ required: true, message: '请输入现住详细地址' }]}
                            >
                                <Input placeholder="现住详细地址" maxLength={100} />
                            </Form.Item>
                        </div>


                        {/* 婚姻状况 */}
                        <div ref={marry_status_arr}>
                            <Form.Item
                                name="marry_status_arr"
                                label='婚姻状况'
                                rules={[{ required: true, message: '请选择婚姻状况' }]}
                            >
                                <Selector
                                    options={marryType?.options.map(item => ({
                                        label: item.name,
                                        value: item.value,
                                    })) ?? []}
                                    onChange={(value) => {
                                        form.setFieldValue('marry_status', value[0]);
                                    }}
                                />
                            </Form.Item>
                        </div>

                        {/* 是否已育 */}
                        <div ref={is_birth_arr}>
                            <Form.Item
                                name="is_birth_arr"
                                label="是否已育"
                                rules={[{ required: true, message: '请选择是否已育' }]}
                            >
                                <Selector
                                    options={[{
                                        label: '是',
                                        value: 1,
                                    },
                                    {
                                        label: '否',
                                        value: 2,
                                    }]}
                                    onChange={(value) => {
                                        form.setFieldValue('is_birth', value[0]);
                                    }}
                                />
                            </Form.Item>
                        </div>

                        {/* 政治面貌 */}
                        <div ref={polity_face_arr}>
                            <Form.Item
                                name="polity_face_arr"
                                label="政治面貌"
                                rules={[{ required: true, message: '请选择政治面貌' }]}
                            >
                                <Selector
                                    options={face?.options.map(item => ({
                                        label: item.name,
                                        value: item.value,
                                    })) ?? []}
                                    onChange={(value) => {
                                        form.setFieldValue('polity_face', value[0]);
                                    }}
                                />
                            </Form.Item>
                        </div>

                        {/* 户口性质 */}
                        <div ref={household_type_arr}>
                            <Form.Item
                                name="household_type_arr"
                                label="户口性质"
                                rules={[{ required: true, message: '请选择户口性质' }]}
                            >
                                <Selector
                                    options={residenceType?.options.map(item => ({
                                        label: item.name,
                                        value: item.value,
                                    })) ?? []}
                                    onChange={(value) => {
                                        form.setFieldValue('household_type', value[0]);
                                    }}
                                />
                            </Form.Item>
                        </div>

                        {/* 个人邮箱 */}
                        <div ref={email}>
                            <Form.Item
                                name="email"
                                label="个人邮箱"
                                rules={[{ type: 'email', message: '请输入正确的邮箱地址' }]}
                            >
                                <Input placeholder="个人邮箱" maxLength={50} />
                            </Form.Item>
                        </div>

                        {/* QQ号 */}
                        <Form.Item name="qq" label="QQ号">
                            <Input placeholder="QQ号" maxLength={20} />
                        </Form.Item>

                        {/* 微信号 */}
                        <Form.Item name="wechat" label="微信号">
                            <Input placeholder="微信号" maxLength={20} />
                        </Form.Item>

                        {/* 银行卡 */}
                        <Form.Item
                            label="银行卡"
                        >
                            <img
                                src={inputBankCardImg ?? bankCardImg}
                                style={{ width: "40%", margin: "0 30%", cursor: 'pointer', objectFit: 'contain' }}
                                alt="银行卡"
                                onClick={() => inputBankCardRef.current?.click()}
                            />
                            <input
                                ref={inputBankCardRef}
                                style={{ display: 'none' }}
                                type="file"
                                accept='image/jpeg,image/jpg,image/png'
                                onChange={uploadBankCard}
                            />
                        </Form.Item>

                        {/* 银行名称 */}
                        <Form.Item name="bank_name" label="银行名称">
                            <Input placeholder="银行名称" maxLength={20} />
                        </Form.Item>

                        {/* 银行卡号 */}
                        <Form.Item name="bank_no" label="银行卡号">
                            <Input placeholder="银行卡号" maxLength={20} />
                        </Form.Item>

                        {/* 教育经历 */}
                        <Form.Array
                            name='edu_exp'
                            onAdd={operation => operation.add({ school: '', begin: '', end: '' })}
                            renderAdd={() => (
                                <span>
                                    <AddCircleOutline /> 添加教育经历
                                </span>
                            )}
                            renderHeader={({ index }, { remove }) => (
                                <>
                                    <span>教育经历{index + 1}</span>
                                    <a onClick={() => remove(index)} style={{ float: 'right' }}>
                                        删除
                                    </a>
                                </>
                            )}
                        >
                            {fields =>
                                fields.map(({ index }) => (
                                    <>
                                        <Form.Item
                                            name={[index, 'begin_obj']}
                                            label="入学时间"
                                            required
                                        >
                                            <Space align='center'>
                                                <Button
                                                    onClick={() => {
                                                        setEduBeginDatePickerVisible(true)
                                                    }}
                                                >
                                                    选择
                                                </Button>
                                                <Form.Item
                                                    name={[index, 'begin_obj']}
                                                    trigger="onConfirm"
                                                    noStyle
                                                    rules={[{ required: true, message: '请选择入学时间' }]}

                                                >
                                                    <DatePicker
                                                        visible={eduBeginDatePickerVisible}
                                                        onClose={() => {
                                                            setEduBeginDatePickerVisible(false)
                                                        }}
                                                        max={now}
                                                        min={minDate}
                                                        onConfirm={(value) => {
                                                            form.setFieldValue(['edu_exp', index, 'begin'], dayjs(value).format('YYYY-MM-DD'));
                                                        }}
                                                    >
                                                        {value => value ? dayjs(value).format('YYYY-MM-DD') : '未选择'}
                                                    </DatePicker>
                                                </Form.Item>
                                            </Space>
                                        </Form.Item>
                                        <Form.Item
                                            name={[index, 'end_obj']}
                                            label="毕业时间"
                                            required
                                        >
                                            <Space align='center'>
                                                <Button
                                                    onClick={() => {
                                                        setEduEndDatePickerVisible(true)
                                                    }}
                                                >
                                                    选择
                                                </Button>
                                                <Form.Item
                                                    name={[index, 'end_obj']}
                                                    trigger="onConfirm"
                                                    noStyle
                                                    rules={[{ required: true, message: '请选择毕业时间' }]}

                                                >
                                                    <DatePicker
                                                        visible={eduEndDatePickerVisible}
                                                        onClose={() => {
                                                            setEduEndDatePickerVisible(false)
                                                        }}
                                                        max={now}
                                                        min={minDate}
                                                        onConfirm={(value) => {
                                                            form.setFieldValue(['edu_exp', index, 'end'], dayjs(value).format('YYYY-MM-DD'));
                                                        }}
                                                    >
                                                        {value => value ? dayjs(value).format('YYYY-MM-DD') : '未选择'}
                                                    </DatePicker>
                                                </Form.Item>
                                            </Space>
                                        </Form.Item>
                                        <Form.Item
                                            name={[index, 'school']}
                                            label='毕业院校'
                                            rules={[{ required: true, message: '毕业院校不能为空' }]}
                                        >
                                            <Input placeholder='请输入毕业院校' />
                                        </Form.Item>
                                    </>
                                ))
                            }
                        </Form.Array>

                        <Form.Array
                            name='job_exp'
                            onAdd={operation => operation.add({ company: '', begin: '', end: '' })}
                            renderAdd={() => (
                                <span>
                                    <AddCircleOutline /> 添加工作经历
                                </span>
                            )}
                            renderHeader={({ index }, { remove }) => (
                                <>
                                    <span>教育经历{index + 1}</span>
                                    <a onClick={() => remove(index)} style={{ float: 'right' }}>
                                        删除
                                    </a>
                                </>
                            )}
                        >
                            {fields =>
                                fields.map(({ index }) => (
                                    <>
                                        <Form.Item
                                            name={[index, 'begin_obj']}
                                            label="就职时间"
                                            required
                                        >
                                            <Space align='center'>
                                                <Button
                                                    onClick={() => {
                                                        setJobBeginDatePickerVisible(true)
                                                    }}
                                                >
                                                    选择
                                                </Button>
                                                <Form.Item
                                                    name={[index, 'begin_obj']}
                                                    trigger="onConfirm"
                                                    noStyle
                                                    rules={[{ required: true, message: '请选择就职时间' }]}

                                                >
                                                    <DatePicker
                                                        visible={jobBeginDatePickerVisible}
                                                        onClose={() => {
                                                            setJobBeginDatePickerVisible(false)
                                                        }}
                                                        max={now}
                                                        min={minDate}
                                                        onConfirm={(value) => {
                                                            form.setFieldValue(['job_exp', index, 'begin'], dayjs(value).format('YYYY-MM-DD'));
                                                        }}
                                                    >
                                                        {value => value ? dayjs(value).format('YYYY-MM-DD') : '未选择'}
                                                    </DatePicker>
                                                </Form.Item>
                                            </Space>
                                        </Form.Item>
                                        <Form.Item
                                            name={[index, 'end_obj']}
                                            label="离职时间"
                                            required
                                        >
                                            <Space align='center'>
                                                <Button
                                                    onClick={() => {
                                                        setJobEndDatePickerVisible(true)
                                                    }}
                                                >
                                                    选择
                                                </Button>
                                                <Form.Item
                                                    name={[index, 'end_obj']}
                                                    trigger="onConfirm"
                                                    noStyle
                                                    rules={[{ required: true, message: '请选择离职时间' }]}

                                                >
                                                    <DatePicker
                                                        visible={jobEndDatePickerVisible}
                                                        onClose={() => {
                                                            setJobEndDatePickerVisible(false)
                                                        }}
                                                        max={now}
                                                        min={minDate}
                                                        onConfirm={(value) => {
                                                            form.setFieldValue(['job_exp', index, 'end'], dayjs(value).format('YYYY-MM-DD'));
                                                        }}
                                                    >
                                                        {value => value ? dayjs(value).format('YYYY-MM-DD') : '未选择'}
                                                    </DatePicker>
                                                </Form.Item>
                                            </Space>
                                        </Form.Item>
                                        <Form.Item
                                            name={[index, 'company']}
                                            label='就职工作单位/企业'
                                            rules={[{ required: true, message: '就职工作单位/企业不能为空' }]}
                                        >
                                            <Input placeholder='请输入就职工作单位/企业' />
                                        </Form.Item>
                                    </>
                                ))
                            }
                        </Form.Array>

                        <Form.Item name="other_image" label="其他附件">
                            <Grid columns={2} gap={10}>
                                <Grid.Item>
                                    <img
                                        src={inputStockPhotoImg ?? stockPhotosImg}
                                        style={{ width: "80%", cursor: 'pointer', margin: '0 10%', objectFit: 'contain' }}
                                        alt="个人证件照"
                                        onClick={() => inputStockPhotoRef.current?.click()}
                                    />

                                    <input
                                        ref={inputStockPhotoRef}
                                        style={{ display: 'none' }}
                                        type="file"
                                        accept='image/jpeg,image/jpg,image/png'
                                        onChange={uploadStockPhoto}
                                    />
                                </Grid.Item>
                                <Grid.Item>
                                    <img
                                        src={inputAcademicCredentialImg ?? academicCredentialsImg}
                                        style={{ width: "80%", cursor: 'pointer', margin: '0 10%', objectFit: 'contain' }}
                                        alt="学历证明"
                                        onClick={() => inputAcademicCredentialRef.current?.click()}

                                    />
                                    <input
                                        ref={inputAcademicCredentialRef}
                                        style={{ display: 'none' }}
                                        type="file"
                                        accept='image/jpeg,image/jpg,image/png'
                                        onChange={uploadAcademicCredential}
                                    />
                                </Grid.Item>
                            </Grid>
                        </Form.Item>

                        <Form.Item name="social_fund_image" label="社保公积金卡">
                            <Grid columns={2} gap={10}>
                                <Grid.Item>
                                    <img
                                        src={inputSocialCardImg ?? socialCardImg}
                                        style={{ width: "80%", cursor: 'pointer', margin: '0 10%', objectFit: 'contain' }}
                                        alt="社保卡"
                                        onClick={() => inputSocialCardRef.current?.click()}
                                    />

                                    <input
                                        ref={inputSocialCardRef}
                                        style={{ display: 'none' }}
                                        type="file"
                                        accept='image/jpeg,image/jpg,image/png'
                                        onChange={uploadSocialCard}
                                    />
                                </Grid.Item>
                                <Grid.Item>
                                    <img
                                        src={inputFundCardImg ?? fundCardImg}
                                        style={{ width: "80%", cursor: 'pointer', margin: '0 10%', objectFit: 'contain' }}
                                        alt="公积金卡"
                                        onClick={() => inputFundCardRef.current?.click()}
                                    />
                                    <input
                                        ref={inputFundCardRef}
                                        style={{ display: 'none' }}
                                        type="file"
                                        accept='image/jpeg,image/jpg,image/png'
                                        onChange={uploadFundCard}
                                    />
                                </Grid.Item>
                            </Grid>
                        </Form.Item>

                        <Form.Item name="leaving_certificate_image" label="离职证明">
                            <img
                                src={inputLeavingCertificateImg ?? leavingCertificateImg}
                                style={{ width: "40%", margin: "0 30%", cursor: 'pointer', objectFit: 'contain' }}
                                alt="离职证明"
                                onClick={() => inputLeavingCertificateRef.current?.click()}
                            />

                            <input
                                ref={inputLeavingCertificateRef}
                                style={{ display: 'none' }}
                                type="file"
                                accept='image/jpeg,image/jpg,image/png'
                                onChange={uploadLeavingCertificate}
                            />
                        </Form.Item>


                        <div ref={is_disease_arr}>
                            <Form.Item
                                label="是否有重大疾病或家族病史"
                                name="is_disease_arr"
                                rules={[{ required: true, message: '请选择是否有重大疾病或家族病史' }]}
                            >
                                <Selector
                                    options={[{
                                        label: '是',
                                        value: 1,
                                    },
                                    {
                                        label: '否',
                                        value: 2,
                                    }]}
                                    onChange={(value) => {
                                        form.setFieldValue('is_disease', value[0]);
                                    }}
                                />
                            </Form.Item>
                        </div>

                        <div ref={disease_desc}>
                            <Form.Item
                                noStyle
                                shouldUpdate={
                                    (prevValues, curValues) =>
                                        prevValues.is_disease !== curValues.is_disease
                                }
                            >
                                {({ getFieldValue }) => {
                                    return getFieldValue('is_disease') === 1
                                        ? <Form.Item
                                            name="disease_desc"
                                            label="详细说明"
                                            rules={[{ required: true, message: '有重大疾病或家族病史请填写' }]}
                                        >
                                            <Input placeholder="详细信息" maxLength={200} />
                                        </Form.Item>
                                        : <></>
                                }}
                            </Form.Item>
                        </div>

                        <div ref={is_disability_arr}>
                            <Form.Item
                                label="是否曾被认定工伤或持有残疾人证明"
                                name="is_disability_arr"
                                rules={[{ required: true, message: '请选择是否曾被认定工伤或持有残疾人证明' }]}
                            >
                                <Selector
                                    options={[{
                                        label: '是',
                                        value: 1,
                                    },
                                    {
                                        label: '否',
                                        value: 2,
                                    }]}
                                    onChange={(value) => {
                                        form.setFieldValue('is_disability', value[0]);
                                    }}
                                />
                            </Form.Item>
                        </div>

                        <div ref={disability_desc}>
                            <Form.Item
                                noStyle
                                shouldUpdate={
                                    (prevValues, curValues) =>
                                        prevValues.is_disability !== curValues.is_disability
                                }
                            >
                                {({ getFieldValue }) => {
                                    return getFieldValue('is_disability') === 1
                                        ? <Form.Item
                                            name="disability_desc"
                                            label="详细说明"
                                            rules={[{ required: true, message: '有曾被认定工伤或持有残疾人证明请填写' }]}
                                        >
                                            <Input placeholder="详细信息" maxLength={200} />
                                        </Form.Item>
                                        : <></>
                                }}
                            </Form.Item>
                        </div>

                        <div ref={is_done_harmful_job_arr}>
                            <Form.Item
                                label="是否从事过特别繁重体力劳动及有毒有害工种"
                                name="is_done_harmful_job_arr"
                                rules={[{ required: true, message: '请选择是否从事过特别繁重体力劳动及有毒有害工种' }]}
                            >
                                <Selector
                                    options={[{
                                        label: '是',
                                        value: 1,
                                    },
                                    {
                                        label: '否',
                                        value: 2,
                                    }]}
                                    onChange={(value) => {
                                        form.setFieldValue('is_done_harmful_job', value[0]);
                                    }}
                                />
                            </Form.Item>
                        </div>

                        <div ref={harmful_job_desc}>
                            <Form.Item
                                noStyle
                                shouldUpdate={
                                    (prevValues, curValues) =>
                                        prevValues.is_done_harmful_job !== curValues.is_done_harmful_job
                                }
                            >
                                {({ getFieldValue }) => {
                                    return getFieldValue('is_done_harmful_job') === 1
                                        ? <Form.Item
                                            name="harmful_job_desc"
                                            label="详细说明"
                                            rules={[{ required: true, message: '有从事过特别繁重体力劳动及有毒有害工种请填写' }]}
                                        >
                                            <Input placeholder="详细信息" maxLength={200} />
                                        </Form.Item>
                                        : <></>
                                }}
                            </Form.Item>
                        </div>

                        <div ref={is_occupational_disease_arr}>
                            <Form.Item
                                label="是否有职业病或慢性病影响工作的疾病或怀孕"
                                name="is_occupational_disease_arr"
                                rules={[{ required: true, message: '请选择是否有职业病或慢性病影响工作的疾病或怀孕' }]}
                            >
                                <Selector
                                    options={[{
                                        label: '是',
                                        value: 1,
                                    },
                                    {
                                        label: '否',
                                        value: 2,
                                    }]}
                                    onChange={(value) => {
                                        form.setFieldValue('is_occupational_disease', value[0]);
                                    }}
                                />
                            </Form.Item>
                        </div>

                        <div ref={occupational_disease_desc}>
                            <Form.Item
                                noStyle
                                shouldUpdate={
                                    (prevValues, curValues) =>
                                        prevValues.is_occupational_disease !== curValues.is_occupational_disease
                                }
                            >
                                {({ getFieldValue }) => {
                                    return getFieldValue('is_occupational_disease') === 1
                                        ? <Form.Item
                                            name="occupational_disease_desc"
                                            label="详细说明"
                                            rules={[{ required: true, message: '有职业病或慢性影响工作的疾病或怀孕请填写' }]}
                                        >
                                            <Input placeholder="详细信息" maxLength={200} />
                                        </Form.Item>
                                        : <></>
                                }}
                            </Form.Item>
                        </div>

                        {/* 联系人姓名 */}
                        <div ref={ec_name}>
                            <Form.Item
                                name="ec_name"
                                label="联系人姓名"
                                rules={[{ required: true, message: '请输入联系人姓名' }]}
                            >
                                <Input placeholder="联系人姓名" maxLength={10} />
                            </Form.Item>
                        </div>

                        {/* 联系人关系 */}
                        <div ref={ec_relation_arr}>
                            <Form.Item
                                name="ec_relation_arr"
                                label="联系人关系"
                                rules={[{ required: true, message: '请选择联系人关系' }]}
                            >
                                <Selector
                                    options={relationship?.options.map(item => ({
                                        label: item.name,
                                        value: item.value,
                                    })) ?? []}
                                    onChange={(value) => {
                                        form.setFieldValue('ec_relation', value[0]);
                                    }}
                                />
                            </Form.Item>
                        </div>

                        {/* 联系人电话 */}
                        <div ref={ec_mobile}>
                            <Form.Item
                                name="ec_mobile"
                                label="联系人电话"
                                rules={[{ required: true, message: '请输入联系人电话' }]}
                            >
                                <Input placeholder="联系人电话" maxLength={11} />
                            </Form.Item>
                        </div>

                        {/* 联系人地址 */}
                        <div ref={ec_address}>
                            <Form.Item
                                name="ec_address"
                                label="联系人地址"
                                rules={[{ required: true, message: '请填写联系人地址' }]}
                            >
                                <Input placeholder="联系人地址" maxLength={100} />
                            </Form.Item>
                        </div>
                    </>
                }
                {
                    step === 2 &&
                    <Result
                        status='waiting'
                        title='等待入职审核'
                        description={
                            <>
                                您的入职申请已提交，等待管理员审核。
                                <br></br>
                                点击下方按钮下载思博达app。
                            </>
                        }
                    />
                }
                {
                    step === 3 &&
                    <Result
                        status='error'
                        title='二维码参数有误'
                        description='入职无法进行，请使用正确的二维码。'
                    />
                }
            </Form>
            <SafeArea position='bottom' />
        </>
    );
}

export default RegisterPage;
